export const LOGO = require('./jgg_logo.png'); 
export const BASE = require('./base.png'); 
export const FRAME = require('./frame.png'); 
